import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import useTitle from "../../hooks/useTitle";

// components
import Hero from "../../components/Home/Hero";
import DailyQuotes from "../../components/Home/DailyQuotes";

const HomePage = () => {
	useTitle("Home");

	return (
		<div className="">
			<Hero />
			<DailyQuotes />
		</div>
	);
};

export default HomePage;
